import CircularProgress from "@mui/material/CircularProgress";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import useButtonStyles from "../../styles/useButtonStyles";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useDispatch } from "react-redux";
import { financeActions } from "../../redux/slices/financeSlice";
import theme from "../../theme";
import { EVoucherColumns, EVoucherColumns1 } from "../../static-models/finance";
import { useAppSelector } from "../../redux/hooks";
import { constant } from "../../constants";
import {
  formatDateReport,
  getEncodedLastkey,
  getEncodedValue,
} from "../forms/utility";
import formatDate from "../../util/dateFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import InputProps, { DualInputProps } from "../../pages/SharedContents/InputProps";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import BasicModal from "../ui/BasicModal";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { exportData } from "../../services/ApiServices/export";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  modelName,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import useDateFilter from "../../Hooks/Filters/useDateFilter";

export function Evoucher() {
  const buttonStyle = useButtonStyles();
  const { getUserPermission: getEvoucherPermission } = usePermissionGetter(
    "finance",
    "reimbursment_evoucher"
  );
  const [approval, setApproval] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAPI, setLoadingAPI] = useState(false); // New state variable
  const dispatch = useDispatch();
  const [eVoucher, setEVoucher] = useState([]);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [apiError, setApiError] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState("Something Went Wrong");
  const [openAddDeduct, setOpenAddDeduct] = useState<boolean>(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedItems, setSelectedItems] = useState<EVoucherData[]>([]);
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantId } = selectedMerchatDetails;
  const currentDate = formatDateReport(new Date().toISOString());
  const [filterActive, setFilterActive] = useState(false);

  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [updatedAmntInput, setUpdatedAmntInput] = useState({});
  const [selectedOption, setSelecteOption] = useState("");
  const [isApiCall, setApiCall] = useState<boolean>(true);
  const [lastKey, setLastKey] = useState(null);

  const dropdownOptions = [
    { id: filterConstants.Pending, label: filterConstants.Pending },
    { id: filterConstants.Submitted, label: filterConstants.Submitted },
    { id: filterConstants.Rejected, label: filterConstants.Rejected },
  ];
  const searchInputRef = useRef<HTMLInputElement>();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();

  const entityConstants = {
    amount: "reimbursement_cost",
    submittedDate: "submitted_date",
    receivedDate: "reimbursement_date",
    createdDate: "created_date",
    status: "report_status",
  };
  const { selectedDates, onUpdateFiltedDate, valueWithOperator, onResetDate } =
    useDateFilter([
      entityConstants.submittedDate,
      entityConstants.receivedDate,
    ]);
  const inputConstants = {
    amnt_from: "amount_from",
    amnt_to: "amount_to",
  };

  interface EVoucherData {
    id: string;
    reportId: string;
    merchant: number;
    companyName: number;
    voucherType: string;
    totalAmount: string;
    noOfVoucher: string;
    rejectionReason: string;
    createdBy: string;
    reportStatus: string;
    submittedDate: string;
    receivedDate: string;
  }
  const permissions = useAppSelector((state: any) => state.persistReducers);

  useEffect(() => {
    if (isApiCall) bindFilter();
  }, [isApiCall]);

  const handleClickOpen = () => {
    setOpen(true);
    setOpenAddDeduct(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenAddDeduct(true);
  };
  const handleExportClose = () => {
    setOpenExport(false);
  };

  const handleCheckboxChange = (item: EVoucherData, checked: boolean) => {
    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    } else {
      setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.filter((selectedItem) => selectedItem !== item)
      );
    }
  };
  const getNormalFilter = () => {
    let filterItems = [
      {
        fieldValue: "voucher_type",
        operator: operatorConstants.equal,
        value: "Evouchers",
      },
    ];
    if (constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN) {
      const merchantid = {
        fieldValue: "id",
        operator: operatorConstants.equal,
        value: merchantId,
      };
      filterItems = [...filterItems, merchantid];
    }
    return filterItems;
  };
  const getParam = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const filterItems = getNormalFilter();
    const params = {
      hashData: hashValues,
      filterData: filterItems,
    };
    return params;
  };

  const getAPiURL = (queryParam?: any) => {
    let apiURL = `${process.env.REACT_APP_API_URL}`;
    apiURL +=
      constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
        ? `${APIConstants.getMerchantReport}`
        : `${APIConstants.getReimbursementEvoucher}`;
    const filterParams = getHashURL(queryParam ? queryParam : getParam());
    const module =
      constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
        ? APIModuleConstants.merchantEvoucher
        : APIModuleConstants.pvoucher;
    if (!eVoucher.length) getTotalRecordsCount(module, filterParams);
    apiURL += `?${filterParams}`;
    apiURL += `&module=finance&feature=reimbursment_evoucher`;
    return apiURL;
  };

  const getVoucher = async (
    queryparam?: any,
    canHaveExistingData?: boolean
  ) => {
    setLoading(true);
    try {
      let apiUrl = getAPiURL(queryparam);
      if (lastKey) {
        apiUrl += (apiUrl ? "&" : "?") + getEncodedLastkey(lastKey);
      }
      const voucherResponse = await axios.get(apiUrl);
      const data = voucherResponse.data.data.data.value;
      const apiKey = voucherResponse.data.data.data.lastKey
        ? voucherResponse.data.data.data.lastKey
        : null;
      setLastKey(apiKey);
      const mappedData = data.map((voucher: any) => ({
        reportId: voucher.report_id ? voucher.report_id : "-",
        merchant: voucher.merchant_name ? voucher.merchant_name : "-",
        companyName: voucher.company_name ? voucher.company_name : "-",
        voucherType: voucher.voucher_type ? voucher.voucher_type : "-",
        totalAmount: voucher.reimbursement_cost
          ? `S$ ${voucher.reimbursement_cost}`
          : "S$ 0",
        noOfVoucher: voucher.voucher_count ? voucher.voucher_count : "-",
        merchantId: voucher.merchant_id ? voucher.merchant_id : "-",
        createdAt: voucher.createdAt ? formatDate(voucher.createdAt) : "-",
        submittedDate: voucher.submitted_date
          ? formatDate(voucher.submitted_date)
          : "-",
        // receivedDate: voucher.updatedAt ? formatDate(voucher.updatedAt) : "-",
        receivedDate: voucher?.reimbursement_date
          ? formatDate(voucher.reimbursement_date)
          : "-",
        rejectionReason: voucher.rejection_reason
          ? voucher.rejection_reason
          : "-",
        reportStatus: voucher.report_status ? voucher.report_status : "-",
        navigateTo: `${"/e-voucherDetails/"}${voucher.report_id}`,
      }));
      const dataToSet = canHaveExistingData
        ? [...eVoucher, ...mappedData]
        : mappedData;
      setEVoucher(dataToSet);
      dispatch(
        financeActions.updateEVoucherList({
          eVoucherList: dataToSet,
        })
      );
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setApiCall(false);
    }
  };
  const handleProceed = async () => {
    const validItems = selectedItems.filter(
      (voucher) => voucher.reportId && voucher.reportStatus
    );

    if (validItems.length === 0) {
      return;
    }
    const status = approval
      ? filterConstants.Rejected
      : filterConstants.Submitted;
    const ids = validItems.map((voucher: any) => ({
      id: voucher.reportId,
      report_status: status,
      merchantId: voucher.merchantId,
      rejection_reason: approval ? rejectionReason : "",
    }));
    setLoadingAPI(true);
    try {
      const payload = [...ids];
      const newPayload = {
        type: "Evouchers",
        records: payload,
        module: "finance",
        feature: "reimbursment_evoucher",
      };
      const axiosResponse = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.proceedReimbursement,
        newPayload
      );
      setShowModal(true);
      setModalTitle(axiosResponse.data.data.message);
      handleClose();
      setEVoucher([]);
      setLastKey(null);
      setSelectedItems([]);
      setApiCall(true);
    } catch (error) {
      setApiError(true);
      console.error(error);
    } finally {
      setLoadingAPI(false);
      setOpen(false);
      setOpenAddDeduct(false);
      setApiError(false);
      setTimeout(() => setShowModal(false), 5000);
    }
  };
  const headerMapping: Record<string, string> = {
    reportId: "Report ID",
    merchant: "Merchant Name",
    companyName: "Company Name",
    voucherType: "Voucher Type",
    totalAmount: "Total Amount",
    noOfVouchers: "Total Vouchers",
    submissionDate: "Submission Date",
    receivedDate: "Received Date",
    rejectionReason: "Rejection Reason",
    createdBy: "Created By",
    status: "Status",
    merchantID: "Merchant ID",
    noOfVoucher: "No. of voucher(s)",
    merchantId: "Merchant ID",
    submittedDate: "Submission Date",
    reportStatus: "Report Status",
  };

  const formatCSVData = (data: any[]) => {
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
      };
      const excludedColumns = [
        "navigateTo",
        "id",
        "reportIdDetail",
        "voucherType",
        "merchantId",
        "createdAt",
      ];
      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }
      if (renamedRow.navigateTo) {
        delete renamedRow.id;
      }

      return renamedRow;
    });
  };

  // export functionality
  const handleSendExport = async () => {
    const getFilterURL = getAPiURL();
    setSending(true);
    const handleExportFun = await exportData(
      getFilterURL,
      modelName.reimbursementReport,
      hashKey.placeholderId,
      hashValue.allRecords
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };
  const handleLocalDownload = () => {
    const exportableData = formatCSVData(eVoucher);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: E-Voucher Reimbursement Report\nExport Date: ${currentDate}\n${csvRows.join(
        "\n"
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "e-voucher.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };
  const onInputChange = (filedName: string, value: any) => {
    setupdatedDateFilter((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const onInputAmntChange = (filedName: string, value: any) => {
    setUpdatedAmntInput((prevState) => ({
      ...prevState,
      [filedName]: value,
    }));
  };
  const getDateValue = (fieldItem: any) => {
    const item = updatedDateFilter[fieldItem as keyof typeof updatedDateFilter];
    return item !== undefined ? item : "";
  };
  const getAmntValue = (fieldItem: any) => {
    const item = updatedAmntInput[fieldItem as keyof typeof updatedAmntInput];
    return item !== undefined ? item : "";
  };
  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter]
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterAmount = () => {
    const amntData = Object.keys(updatedAmntInput)?.map((item: any) => {
      return updatedAmntInput[item as keyof typeof updatedAmntInput];
    });
    let amntField = {};
    const filterValue = {
      fieldValue: entityConstants.amount,
      value: amntData,
      operator: operatorConstants.between,
    };
    const amnt_data = [];
    amntField = amntData.length > 1 ? amnt_data.push(filterValue) : {};
    return amnt_data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: entityConstants.status,
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterValues = () => {
    const filtertype = getNormalFilter();
    const dates =   valueWithOperator// getFilterDates();
    const amount = getFilterAmount();
    const status = getFilterStatus();
    return [...filtertype, ...dates, ...amount, ...status];
  };
  const bindFilter = (canHaveExistingData?: boolean) => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const filterItems = getFilterValues();
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];
    const params = {
      hashData: hashValues,
      searchData: searchParam,
      filterData: filterItems,
    };
    setOpenFilter(false);
    getVoucher(params, canHaveExistingData);
  };
  const onReset = () => {
    setEVoucher([]);
    setLastKey(null);
    setApiCall(true);
  };
  const handleApplyFilter = () => {
    onReset();
    setOpenFilter(false);
    const filters = getFilterValues().slice(1);
    filters.length && setFilterActive(true);
  };
  const handleResetFilter = () => {
    onResetDate()
    setSelecteOption("");
    setupdatedDateFilter({});
    setUpdatedAmntInput({});
    onReset();
    setFilterActive(false);
  };
  const handleOnCloseFilter = () => {
    setOpenFilter(false);
  };
  const handleSearch = () => {
    onReset();
  };
  const onDisableOptions = (item: any) => {
    return !(
      item?.reportStatus.toLowerCase() ===
        filterConstants.Rejected.toLowerCase() ||
      item?.reportStatus.toLowerCase() ===
        filterConstants.Accepted.toLowerCase() ||
      item?.reportStatus.toLowerCase() ===
        filterConstants.Submitted.toLowerCase()
    );
  };
  return (
    <Grid container width={"100%"} gap={2}>
      {constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN && (
        <Grid
          display={"flex"}
          justifyContent={"left"}
          alignItems={"center"}
          container
          height={"6.25rem"}
          p={4}
          borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
          sx={{
            backgroundColor: theme?.color?.background,
            "&:hover:not(.Mui-disabled)": {
              cursor: "pointer",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              color: theme?.color?.primary,
              fontWeight: "600",
            }}
          >
            E-Voucher Reimbursements
          </Typography>
        </Grid>
      )}
      <Grid
        display={"flex"}
        gap={3}
        width={"100%"}
        alignItems={"center"}
        justifyContent={"space-between"}
        px={4}
        py={3}
      >
        <Grid>
          {getEvoucherPermission("update") && (
            <Button
              sx={{
                ...buttonStyle.containedSecondary,
                background:
                  selectedItems.length === 0 ? theme.color?.secondaryLight : "",
              }}
              onClick={() => setOpenAddDeduct(true)}
              disabled={selectedItems.length === 0}
            >
              Receive / Reject
            </Button>
          )}
        </Grid>
        <Grid display={"flex"} gap={2}>
          {getEvoucherPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              onClick={() => setOpenExport(true)}
              disabled={!eVoucher.length}
            />
          )}
          {getEvoucherPermission("download") && (
            <CommonButton
              buttonTitle="Download"
              variant="text"
              color="secondary"
              onClick={handleLocalDownload}
              disabled={!eVoucher.length}
              endIcon={<DownloadForOfflineRoundedIcon />}
            />
          )}
          {getEvoucherPermission("read") && (
            <SearchInput
              HelpTip={SearchToolTip.VoucherReimb}
              onCallBack={handleSearch}
              ref={searchInputRef}
            />
          )}
          {getEvoucherPermission("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}
        </Grid>
        <ExportDialog
          closeDialog={setOpenExport}
          emailSent={emailSent}
          exportTitle="Reimbursement e-Voucher"
          handleClose={handleExportClose}
          open={openExport}
          sending={sending}
          handleSendExport={handleSendExport}
        />
        <Dialog
          onClose={handleOnCloseFilter}
          open={openFilter}
          sx={{ ml: "60vw" }}
        >
          <Grid sx={{ width: "483px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              <IconButton onClick={handleOnCloseFilter}>
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.medium,
                  fontWeight: theme.font?.fontWeight.thick,
                }}
              >
                Total Amount($)
              </Typography>
              <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                <TextField
                  sx={{
                    display: "flex",
                    width: "50%",
                  }}
                  type="text"
                  placeholder="From"
                  value={getAmntValue(inputConstants.amnt_from)}
                  onChange={(data) =>
                    onInputAmntChange(
                      inputConstants.amnt_from,
                      data.target.value
                    )
                  }
                />
                <TextField
                  sx={{
                    display: "flex",
                    width: "50%",
                  }}
                  type="text"
                  placeholder="To"
                  value={getAmntValue(inputConstants.amnt_to)}
                  onChange={(data) =>
                    onInputAmntChange(inputConstants.amnt_to, data.target.value)
                  }
                />
              </Grid>
              <DualInputProps
                label="Submitted Date"
                fromTitle="From"
                toTitle="To"
                fromOnChange={(data) => {
                  onUpdateFiltedDate(
                    entityConstants.submittedDate,
                    "fromDate",
                    data.target.value
                  );
                }}
                toOnChange={(data) => {
                  onUpdateFiltedDate(
                    entityConstants.submittedDate,
                    "toDate",
                    data.target.value
                  );
                }}
                fromValue={
                  selectedDates[
                    entityConstants.submittedDate
                  ]?.fromDate?.toString() || ""
                }
                toValue={
                  selectedDates[
                    entityConstants.submittedDate
                  ]?.toDate?.toString() || ""
                }
                type="Date"
              />
              {/* <InputProps
                label="Submitted Date"
                value={getDateValue(entityConstants.submittedDate)}
                type="date"
                inputPlaceHolder="From"
                onInputChange={(data) =>
                  onInputChange(
                    entityConstants.submittedDate,
                    data.target.value
                  )
                }
              /> */}
              <DualInputProps
                label="Received Date"
                fromTitle="From"
                toTitle="To"
                fromOnChange={(data) => {
                  onUpdateFiltedDate(
                    entityConstants.receivedDate,
                    "fromDate",
                    data.target.value
                  );
                }}
                toOnChange={(data) => {
                  onUpdateFiltedDate(
                    entityConstants.receivedDate,
                    "toDate",
                    data.target.value
                  );
                }}
                fromValue={
                  selectedDates[
                    entityConstants.receivedDate
                  ]?.fromDate?.toString() || ""
                }
                toValue={
                  selectedDates[
                    entityConstants.receivedDate
                  ]?.toDate?.toString() || ""
                }
                type="Date"
              />
              {/* <InputProps
                label="Received Date"
                value={getDateValue(entityConstants.receivedDate)}
                type="date"
                inputPlaceHolder="From"
                onInputChange={(data) =>
                  onInputChange(entityConstants.receivedDate, data.target.value)
                }
              /> */}
              {/* <InputProps
                label="Created Date"
                value={getDateValue(entityConstants.createdDate)}
                type="date"
                inputPlaceHolder="From"
                onInputChange={(data) =>
                  onInputChange(entityConstants.createdDate, data.target.value)
                }
              /> */}
              <InputProps
                label="Report Status"
                value={selectedOption}
                type="Select"
                inputPlaceHolder="From"
                onInputChange={(data) => {
                  setSelecteOption(data.target.value);
                }}
                options={dropdownOptions}
              />
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                onClick={handleResetFilter}
                sx={{ ...buttonStyle.outlinedSecondary }}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyle.containedSecondary }}
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
      {constant.domain === process.env.REACT_APP_ADMIN_DOMAIN && (
        <Dialog
          open={openAddDeduct}
          onClose={() => {
            setOpenAddDeduct(false);
            setApproval(false);
          }}
          sx={{ mr: "52vw" }}
        >
          <Grid
            display={"flex"}
            gap={4}
            p={4}
            width={"439px"}
            flexDirection={"column"}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thicker,
                fontSize: "20px",
              }}
            >
              Receive or Reject
            </Typography>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="options"
                name="options"
                sx={{ fontFamily: theme.font?.fontFamily.primary }}
              >
                <FormControlLabel
                  sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  control={
                    <Radio
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        color: theme.color?.sideGrey,
                        "&.Mui-checked": {
                          color: theme.color?.secondary,
                        },
                      }}
                      checked={!approval}
                      onChange={() => {
                        setApproval(false);
                      }}
                    />
                  }
                  label="Receive"
                />
                <FormControlLabel
                  sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  control={
                    <Radio
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        color: theme.color?.sideGrey,
                        "&.Mui-checked": {
                          color: theme.color?.secondary,
                        },
                      }}
                      checked={approval}
                      onChange={() => {
                        setApproval(true);
                      }}
                    />
                  }
                  label="Reject"
                />
              </RadioGroup>
            </FormControl>
            {!approval && (
              <Grid
                display={"flex"}
                alignItems={"center"}
                gap={2}
                borderTop={theme.border?.newGreyBorder}
                pt={3}
              >
                <Button
                  sx={{ ...buttonStyle.outlinedSecondary, width: "50%" }}
                  onClick={() => {
                    setOpenAddDeduct(false);
                    setApproval(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ ...buttonStyle.containedSecondary, width: "50%" }}
                  onClick={() => {
                    setOpenAddDeduct(false);
                    handleClickOpen();
                  }}
                >
                  Proceed
                </Button>
              </Grid>
            )}
            {approval && (
              <Grid display={"flex"} gap={4} flexDirection={"column"}>
                <TextField
                  multiline
                  rows={2}
                  placeholder=""
                  label="Reason"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  sx={{ background: theme.color?.background }}
                ></TextField>
                <Grid
                  display={"flex"}
                  gap={2}
                  borderTop={theme.border?.newGreyBorder}
                  pt={3}
                >
                  <Button
                    sx={{ ...buttonStyle.outlinedSecondary, width: "50%" }}
                    onClick={() => {
                      setOpenAddDeduct(false);
                      setApproval(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    sx={{ ...buttonStyle.containedSecondary, width: "50%" }}
                    onClick={handleClickOpen}
                  >
                    Proceed
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Dialog>
      )}
      <Grid container width={"100%"} px={3} mt={1}>
        {getEvoucherPermission("read") && (
          <InfiniteTable
            header={
              constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN
                ? EVoucherColumns1
                : EVoucherColumns
            }
            contentItems={eVoucher}
            onInputChange={handleCheckboxChange}
            hasMoreRecords={lastKey !== null}
            fetchMoreData={() => bindFilter(true)}
            isInitialLoading={eVoucher.length === 0 && loading}
            filterCondition={onDisableOptions}
            totalRecords={totalCount}
          />
        )}
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid width={"491px"} py={2}>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thick,
                textAlign: "center",
                color: "black",
                fontSize: theme.font?.fontSize.large,
              }}
            >
              Are you sure you want to <br></br>{" "}
              {approval
                ? filterConstants.Reject.toLowerCase()
                : filterConstants.receive}{" "}
              this report
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
            {loadingAPI ? (
              <CircularProgress size={24} />
            ) : (
              <>
                <Button
                  sx={{ ...buttonStyle.outlinedSecondary, width: "40%" }}
                  onClick={handleClose}
                  autoFocus
                >
                  Cancel
                </Button>
                <Button
                  sx={{ ...buttonStyle.containedSecondary, width: "40%" }}
                  onClick={handleProceed}
                >
                  OK
                </Button>
              </>
            )}
          </DialogActions>
        </Grid>
      </Dialog>
      {showModal &&
        (apiError ? (
          <BasicModal
            title={modalTitle}
            success={false}
            setState={setShowModal}
          />
        ) : (
          <BasicModal
            title={modalTitle}
            success={true}
            setState={setShowModal}
          />
        ))}
    </Grid>
  );
}
